import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

import { AgenxAlertComponent } from '../../ds/atoms/alert/alert.component';
import { AgenxButtonComponent } from '../../ds/atoms/button/button.component';
import { AgenxCardComponent } from '../../ds/atoms/card/card.component';
import { AgenxInputComponent } from '../../ds/atoms/input/input.component';
import { AgenxPaginatorComponent } from '../../ds/atoms/paginator/paginator.component';
import { AgenxAlertRadioComponent } from '../../ds/moleculs/alert-radio/alert-radio.component';
import { AgenxTabComponent } from '../../ds/moleculs/tab/tab.component';
import { AgenxHeaderComponent } from '../../ds/moleculs/header/header.component';
import { AgenxCardSubComponent } from '../../ds/organism/card-sub/card-sub.component';
import { AgenxTotalsComponent } from '../../ds/templates/totals/totals.component';

import { AccountService } from '../../../services/account.service';
import { DashboardService } from '../../../services/dashboard.service';
import { GaugingService } from '../../../services/gauging.service';
import { SubscriberService } from '../../../services/subscriber.service';
import { ToastService } from '../../../services/toast.service';

import { Flume, Subscriber } from '../../../interfaces/person.interface';
import { CardContent, GaugingFull, SpecialGauge, Totals } from '../../../interfaces/gauging.interface';
import { Microroute } from '../../../interfaces/dashboard.interface';
import { AgenxSelectComponent } from "../../ds/atoms/select/select.component";
import { CardValueContent } from '../../ds/organism/card-sub/card-sub.interface';
import { OfflineService } from '../../../services/offline.service';
import { AgenxCardGaugeComponent } from "../../ds/organism/card-gauge/card-gauge.component";
import { CommonModule } from '@angular/common';
import {
  formatTotal,
  getErrorMessage,
  getFailedPends,
} from '../../../utils/functions';
import { Tab, Tabs } from '../../ds/moleculs/tab/tab.interfaces';
import { NewClientFormComponent } from "../../ds/organism/new-client-form/new-client-form.component";
import { AgenxRadioComponent } from '../../ds/atoms/radio/radio.component';
import { ClientService } from '../../../services/clients.service';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  imports: [
    AgenxHeaderComponent,
    RouterModule,
    ReactiveFormsModule,
    AgenxPaginatorComponent,
    AgenxCardSubComponent,
    AgenxTabComponent,
    AgenxCardComponent,
    AgenxInputComponent,
    AgenxTotalsComponent,
    AgenxButtonComponent,
    AgenxAlertComponent,
    AgenxAlertRadioComponent,
    AgenxSelectComponent,
    AgenxCardGaugeComponent,
    AgenxRadioComponent,
    CommonModule,
    NewClientFormComponent,
  ],
})
export class DashboardComponent {
  private subscriptions: Subscription[] = [];
  user: Flume | null = null;
  date_today = new Date();

  tabs: Tabs | null = {
    notGauging: {
      name: 'SUSCRIPTORES PARA AFORAR',
      active: true,
      pages: [],
      pageSelect: 1,
      records: [],
      cards: [],
      recordsShow: [],
      loading: false,
    },
    searchSubs: {
      name: 'BUSCAR',
      active: false,
      pages: [],
      pageSelect: 1,
      records: [],
      cards: [],
      recordsShow: [],
    },
    gauging: {
      name: 'SUSCRIPTORES AFORADOS',
      active: false,
      pages: [],
      pageSelect: 1,
      records: [],
      cards: [],
      recordsShow: [],
      loading: false,
    },
    specialPend: {
      name: 'AFOROS ESPECIALES PENDIENTES',
      active: false,
      pages: [],
      pageSelect: 1,
      records: [],
      filtered: [],
      cards: [],
      recordsShow: [],
      loading: false,
    },
    specialDone: {
      name: 'AFOROS ESPECIALES REALIZADOS',
      active: false,
      pages: [],
      pageSelect: 1,
      records: [],
      cards: [],
      recordsShow: [],
      loading: false,
    },
    newClient: {
      name: 'CLIENTE NUEVO',
      active: false,
      pages: [],
      pageSelect: 1,
      records: [],
      cards: [],
      recordsShow: [],
      loading: false,
    },
    // empty: {
    //   name: '',
    //   active: false,
    // },
  };

  search_input = new FormControl({ value: '', disabled: false });
  micros_select = new FormControl({ value: '', disabled: false });
  micros_select_spe = new FormControl({ value: '', disabled: false });
  select_prog_spe = new FormControl({ value: '0', disabled: false });
  micros_values: Array<{ value: string; label: string }> = [];
  micros_values_spe: Array<{ value: string; label: string }> = [];
  select_prog_values: Array<{ value: string; label: string }> = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Hoy' },
    { value: '2', label: 'Anteriores' },
  ];

  gauging_pends: Array<GaugingFull> = [];
  special_pends: Array<any> = [];
  all_gauging_today: Array<GaugingFull> = [];
  card_x_page = 12;
  tab_index = 0;
  toast: any = null;
  tabSelected: string = this.tabs!.notGauging.name;
  loading: 'loading' | 'normal' = 'normal';
  btn_restart = '';
  btn_restart_spe = '';
  micro_name = 'SUSCRIPTORES PARA AFORAR';
  micro_name_spe = 'AFOROS ESPECIALES PENDIENTES';
  alertNoSpecials = 'No hay aforos especiales pendientes para hoy.';

  totals_permanent: string = '0 m³ / 0 kg';
  totals_extra: string = '0 m³ / 0 kg';
  totals_ordinary: string = '0 m³ / 0 kg';
  totals_usable: string = '0 m³ / 0 kg';
  totals_unusable: string = '0 m³ / 0 kg';
  totals_organic: string = '0 m³ / 0 kg';
  totals_gauged: string = '0 m³ / 0 kg';
  totals_month: string = '0 m³ / 0 kg';
  totals_today: string = '0 m³ / 0 kg';
  gauged_sub: string = '';
  today_sub: string = '';
  month_subs: string = '';
  show_totals: boolean = false;

  no_internet = false;
  created_pends = false;
  created_pends_specials = false;
  message_pend = '';
  message_pend2 = '';
  message_pend_spe = '';
  message_pend_spe2 = '';
  iconExcl = '';
  week_day = '';
  searchType = 'subscribers';

  constructor(
    private accountSrv: AccountService,
    private clientSrv: ClientService,
    private dashboardSrv: DashboardService,
    private gaugingSrv: GaugingService,
    private offlineSrv: OfflineService,
    private subscriberSrv: SubscriberService,
    private toastSrv: ToastService,
    private router: Router,
  ) {}

  /**
   * Navigates to the create or edit page based on the card information.
   * @param {any} card_info - The card information.
   */
  goToCreateEdit(card_info: any): void {
    if (card_info.cardSubButtonType === 'Create') {
      this.router.navigateByUrl('/create_edit');
      this.offlineSrv.saveToLocal('subs_data', card_info.card_info);
    } else {
      this.onClickSubCard(card_info);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subsciption) => subsciption.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.offlineSrv.onlineStatus$.subscribe((isOnline: boolean) => {
        this.no_internet = !isOnline;
        if (!this.no_internet) {
          this.gauging_pends.length > 0 && this.sendGaugingsPends();
          this.special_pends.length > 0 && this.sendSpecialsPends();
        }
      }),
    );
    this.gauging_pends = this.offlineSrv.loadFromLocal('gauging_pends', []);
    this.special_pends = this.offlineSrv.loadFromLocal(
      'specials_to_create',
      [],
    );
    this.user = this.accountSrv.userValue;
    this.iconExcl = this.offlineSrv.loadAssetInLocal('icon-exclamacion.svg');

    this.gauging_pends.length > 1
      ? (this.message_pend = `se tienen ${this.gauging_pends.length} aforos`)
      : (this.message_pend = 'se tiene 1 aforo');
    this.special_pends.length > 1
      ? (this.message_pend_spe = `se tienen ${this.special_pends.length} aforos especiales`)
      : (this.message_pend_spe = 'se tiene 1 aforo especial');

    if (this.no_internet) {
      this.onGetTotals(this.offlineSrv.loadFromLocal('totals'));
      this.all_gauging_today = this.gauging_pends.concat(
        this.offlineSrv.loadFromLocal('gauging_today', []),
      );
      this.onGetTodayGauging(this.all_gauging_today);
      this.onGetMicroroutes(this.offlineSrv.loadFromLocal('microroutes', []));
      this.onGetSpecialGaugesDone(
        this.offlineSrv.loadFromLocal('specialGaugesDone', []),
      );
    } else {
      this.getTotals();
      this.getTodayGauging();
      this.getMicroroutes();
      this.getSpecialGaugesDone();
      this.gauging_pends.length > 0 && this.sendGaugingsPends();
      this.special_pends.length > 0 && this.sendSpecialsPends();
    }
    this.week_day = String(this.date_today.getDay());
    this.week_day = this.week_day === '0' ? '7' : this.week_day;
  }

  onClickSearch(type: string): void {
    this.searchType = type;
  }

  /**
   * Handles the click event on a subscriber card.
   * @param {*} evt - The event containing the card information.
   */
  onClickSubCard(evt: any): void {
    if (evt.cardSubButtonType === 'Create') {
      this.goToCreateEdit(evt);
    } else if (evt.cardSubButtonType === 'Download') {
      this.toast = this.toastSrv.load('Descargando reporte');
      this.gaugingSrv
        .downloadGaugingReport(evt.card_info.gauging_id)
        .subscribe({
          next: (result: any) => {
            this.toast.close();
            window.open(result.url, '_blank');
          },
          error: (error: { error: { detailed: string } }) => {
            this.toastSrv.error(
              getErrorMessage(error, 'No se pudo descargar el reporte.', this.no_internet),
            );
          },
        });
    } else if (evt.cardSubButtonType === 'Resend') {
      this.toast = this.toastSrv.load('Enviando reporte');
      this.gaugingSrv.resendGaugingReport(evt.card_info.gauging_id).subscribe({
        next: (result: any) => {
          this.toast.close();
          this.toastSrv.success('Se ha enviado el reporte con exito');
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo reenviar el reporte.', this.no_internet),
          );
        },
      });
    }
  }

  private getMicroroutes(): void {
    this.subscriptions.push(
      this.dashboardSrv.getMicroroutes().subscribe({
        next: (micros: Microroute[]) => {
          micros = micros.filter((micro) => micro.dias.includes(this.week_day));
          this.offlineSrv.saveToLocal('microroutes', micros);
          this.onGetMicroroutes(micros);
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  private getSpecialGaugesDone(): void {
    this.tabs!.specialDone.loading = true;
    this.subscriptions.push(
      this.gaugingSrv.getSpecialGaugesDone(this.user?.id!).subscribe({
        next: (result: SpecialGauge[]) => {
          this.offlineSrv.saveToLocal('specialGaugesDone', result);
          this.onGetSpecialGaugesDone(result);
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  private getTodayGauging(): void {
    this.tabs!.gauging.loading = true;
    this.tabs!.gauging.records = this.offlineSrv.loadFromLocal('gauging', []);
    this.subscriptions.push(
      this.gaugingSrv.getTodayGauging().subscribe({
        next: (result: GaugingFull[]) => {
          this.offlineSrv.saveToLocal('gauging_today', result);
          this.onGetTodayGauging(result);
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  private getTotals(): void {
    this.subscriptions.push(
      this.gaugingSrv.getTotals().subscribe({
        next: (totals: Totals) => {
          this.offlineSrv.saveToLocal('totals', totals);
          this.onGetTotals(totals);
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  private onGetMicroroutes(micros: Microroute[]): void {
    this.micros_values.push({ value: '---', label: '---' });
    this.micros_values.push({ value: 'all', label: 'Todas' });
    this.micros_values_spe.push({ value: '---', label: '---' });
    this.micros_values_spe.push({ value: 'all', label: 'Todas' });
    this.micros_values_spe.push({ value: 'programmed', label: 'Programado' });
    micros.forEach((micro) => {
      this.micros_values.push({
        value: micro.id.toString(),
        label: micro.name,
      });
      if (micro.type_id == 9) {
        this.micros_values_spe.push({
          value: micro.id.toString(),
          label: micro.name,
        });
      }
    });
    let micro_saved = this.offlineSrv.loadFromLocal('microroute', null);
    micro_saved
      ? this.setMicroroutes(undefined, micro_saved)
      : this.micros_select.setValue('---');
    let micro_saved_spe = this.offlineSrv.loadFromLocal('microroute_spe');
    micro_saved_spe
      ? this.setMicroroutesSpecial(undefined, micro_saved_spe)
      : this.setMicroroutesSpecial(undefined, {
          value: 'programmed',
          label: 'Programado',
        });
  }

  private onGetSpecialGaugesDone(gaugesSpe: SpecialGauge[]): void {
    this.tabs!.specialDone.pages = [];
    this.tabs!.specialDone.cards = [];
    this.tabs!.specialDone.records = gaugesSpe;
    gaugesSpe.length > 0 && this.setCards('special_done');
    this.tabs!.specialDone.loading = false;
    this.setPaginator(1);
  }

  private onGetTodayGauging(result: GaugingFull[]): void {
    this.tabs!.gauging.pages = [];
    this.tabs!.gauging.cards = [];
    this.tabs!.gauging.records = result;
    this.tabs!.gauging.recordsShow = [];
    result.length > 0 && this.setCards('gauging');
    this.tabs!.gauging.loading = false;
    if (this.no_internet) {
      this.onSearch(this.offlineSrv.loadFromLocal('subscribers_search', []));
    } else {
      this.search_input.setValue(this.offlineSrv.loadFromLocal('search'));
      this.search();
    }
  }

  private onGetTotals(totals: Totals): void {
    if (totals) {
      this.show_totals = true;
      let m3_totals =
        totals.months_totals[1].m3 +
        totals.months_totals[2].m3 +
        totals.months_totals[3].m3;
      let kgrs_totals =
        totals.months_totals[1].kgrs +
        totals.months_totals[2].kgrs +
        totals.months_totals[3].kgrs;
      const today = totals.today_totals;
      this.totals_gauged = formatTotal(m3_totals, kgrs_totals);
      this.totals_month = formatTotal(
        totals.months_totals[0].m3,
        totals.months_totals[0].kgrs,
      );
      this.totals_today = formatTotal(today.m3, today.kgrs);
      this.totals_permanent = formatTotal(today.permanent_m3, today.permanent_kgrs);
      this.totals_extra = formatTotal(today.extra_m3, today.extra_kgrs);
      this.totals_ordinary = formatTotal(today.ordinary_m3, today.ordinary_kgrs);
      this.totals_usable = formatTotal(today.usable_m3, today.usable_kgrs);
      this.totals_unusable = formatTotal(today.unusable_m3, today.unusable_kgrs);
      this.totals_organic = formatTotal(today.organic_m3, today.organic_kgrs);
      this.gauged_sub = totals.gauged_sub;
      this.month_subs = totals.months_subs[0];
      this.today_sub = totals.today_sub;
    }
  }

  private sendGaugingsPends(): void {
    const pends = this.gauging_pends;
    const payload = pends.map((gau: any) => {
      const { subscriber, id, m3, kgrs, pend, ...data } = gau;
      return data;
    });
    this.created_pends = false;
    this.subscriptions.push(
      this.offlineSrv.saveGaugingsPends({ gaugings_list: payload }).subscribe({
        next: (result: any) => {
          const failed = getFailedPends(pends, payload, result.errors);
          if (result.success.length > 0) {
            this.message_pend2 =
              result.success.length > 1
                ? `Se crearon ${result.success.length} aforos de manera satisfactoria, los cuales estaban pendientes por falta de conexión.`
                : 'Se creó 1 aforo de manera satisfactoria, el cual estaba pendiente por falta de conexión.';
            let aux = result.success.concat(
              this.offlineSrv.loadFromLocal('gauging_today', []),
            );
            this.onGetTodayGauging(aux);
            this.offlineSrv.saveToLocal('gauging_today', aux);
            this.created_pends = failed.length === 0;
          }
          if (failed.length > 0) {
            this.message_pend =
              failed.length > 1
                ? `se tienen ${failed.length} aforos`
                : 'se tiene 1 aforo';
            this.offlineSrv.saveToLocal('gauging_pends', failed);
            this.toastSrv.error(
              'No se pudieron crear los aforos de los siguientes suscriptores (Niud): ' +
                failed.map((gau: any) => gau.subscriber?.niud).join(', ') +
                '. Quedan pendientes por crear.',
            );
          } else {
            this.offlineSrv.removeFromLocal('gauging_pends');
          }
          this.gauging_pends = failed;
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  private sendSpecialsPends(): void {
    const pends = this.special_pends;
    this.created_pends_specials = false;
    this.subscriptions.push(
      this.offlineSrv.saveSpecialsPends({ gaugings_list: pends }).subscribe({
        next: (result: any) => {
          const failed = getFailedPends(pends, pends, result.errors);
          if (result.success.length > 0) {
            this.message_pend_spe2 =
              result.success.length > 1
                ? `Se crearon ${result.success.length} aforos especiales de manera satisfactoria, los cuales estaban pendientes por falta de conexión.`
                : 'Se creó 1 aforo especial de manera satisfactoria, el cual estaba pendiente por falta de conexión.';
            let newRecord = this.tabs?.specialPend.records!.filter(
              (record) =>
                !result.success.find((gau: any) => gau.id === record.id),
            );
            let aux = result.success.concat(
              this.offlineSrv.loadFromLocal('specialGaugesDone', []),
            );
            this.onGetSpecialGaugesDone(aux);
            this.onSetMicroroutesSpecials(newRecord!, '', null);
            this.offlineSrv.saveToLocal('specialGaugesDone', aux);
            this.created_pends_specials = failed.length === 0;
          }
          if (failed.length > 0) {
            this.message_pend_spe =
              failed.length > 1
                ? `se tienen ${failed.length} aforos especiales`
                : 'se tiene 1 aforo especial';
            this.offlineSrv.saveToLocal('specials_to_create', failed);
            this.toastSrv.error(
              `No se pudieron crear ${failed.length} aforos especiales. Quedan pendientes por crear.`,
            );
          } else {
            this.offlineSrv.removeFromLocal('specials_to_create');
          }
          this.special_pends = failed;
        },
        error: (error: { error: { detailed: string } }) => {
          this.toastSrv.error(
            getErrorMessage(error, 'No se pudo obtener la información.', this.no_internet),
          );
        },
      }),
    );
  }

  /**
   * Sets the cards to be displayed based on the specified type.
   * @param { 'search' | 'not_gauging' | 'gauging' | 'special_pend' | 'special_done'} type - The type of cards to set.
   */
  private setCards(
    type:
      | 'search'
      | 'not_gauging'
      | 'gauging'
      | 'special_pend'
      | 'special_done',
  ): void {
    let values_content: Array<CardValueContent> = [];
    let array_gauging = this.tabs!.gauging.records;
    let array_subs = this.tabs!.searchSubs.records;
    let array_cards: any = this.tabs!.searchSubs.cards;
    let array_pages = this.tabs!.searchSubs.pages;
    let aux_content!: CardContent;

    if (type === 'not_gauging') {
      array_subs = this.tabs!.notGauging.records;
      array_cards = this.tabs!.notGauging.cards;
      array_pages = this.tabs!.notGauging.pages;
    } else if (type === 'gauging') {
      array_cards = this.tabs!.gauging.cards;
      array_pages = this.tabs!.gauging.pages;
    } else if (type === 'special_pend') {
      array_cards = this.tabs!.specialPend.filtered;
      array_pages = this.tabs!.specialPend.pages;
    } else if (type === 'special_done') {
      array_cards = this.tabs!.specialDone.records;
      array_pages = this.tabs!.specialDone.pages;
    }

    if (['not_gauging'].includes(type)) {
      array_subs!.forEach((subsc, index) => {
        values_content = [
          { title: 'Niud:', value: subsc.niud },
          { title: 'Nombre:', value: subsc.name },
          { title: 'Dirección:', value: subsc.address },
          { title: 'Contrato:', value: subsc.contract },
          { title: 'Estrato:', value: `${subsc.stratum}` },
        ];
        aux_content = {
          valuesContent: values_content,
          id: subsc.id,
          email: subsc.email,
          stratum_id: subsc.stratum_id,
          identification: subsc.identification,
          gaugin_code: subsc.gaugin_code,
          gauging: subsc.gauging,
        };
        if (subsc.rate_type !== 'Aforo') {
          aux_content['alertInfo'] = {
            alertText: 'Este suscriptor no cuenta con tipo tarifa de aforo.',
            alertType: 'warning',
          };
        }
        array_cards.push(aux_content);
      });
    } else if (type === 'gauging') {
      array_gauging!.forEach((gau, index) => {
        values_content = [
          { title: 'Niud:', value: gau.subscriber.niud },
          { title: 'Nombre:', value: gau.subscriber.name },
          { title: 'Dirección:', value: gau.subscriber.address },
          { title: 'M³ Volumen:', value: `${gau.m3}` },
          { title: 'Kg Totales:', value: `${gau.kgrs}` },
        ];
        aux_content = {
          valuesContent: values_content,
          id: gau.subscriber.id,
          gauging_id: gau.id,
          email: gau.subscriber.email,
          stratum_id: gau.subscriber.stratum_id,
          identification: gau.subscriber.identification,
          gaugin_code: gau.subscriber.gaugin_code,
          gauging: gau.subscriber.gauging,
        };
        if (gau.hasOwnProperty('pend')) {
          aux_content['alertInfo'] = {
            alertText: 'Aforo pendiente por crear, cuando haya conexión.',
            alertType: 'warning',
          };
        } else if (gau.subscriber.rate_type !== 'Aforo') {
          aux_content['alertInfo'] = {
            alertText: 'Este suscriptor no cuenta con tipo tarifa de aforo.',
            alertType: 'warning',
          };
        }
        array_cards.push(aux_content);
      });
    }

    let n_pages = array_cards.length / this.card_x_page;
    !Number.isInteger(n_pages) && (n_pages += 1);
    for (let index = 1; index <= n_pages; index++) {
      array_pages!.push(index);
    }

    this.setPaginator(1);
    this.loading = 'normal';
    this.offlineSrv.saveToLocal('search', this.search_input.value!);
  }

  /**
   * Restart the tab 'SUSCRIPTORES PARA AFORAR'
   */
  restartMicroTab(): void {
    if (this.tabSelected == 'SUSCRIPTORES PARA AFORAR') {
      this.micro_name = this.tabSelected;
      this.tabs!.notGauging.active = true;
      this.tabSelected = this.tabs!.notGauging.name;
      this.micros_select.setValue('---');
      this.tabs!.notGauging.pages = [];
      this.tabs!.notGauging.records = [];
      this.tabs!.notGauging.recordsShow = [];
      this.btn_restart = '';
      this.offlineSrv.saveToLocal('not_gauging', []);
    } else {
      // this.tabSelected = this.tabs!.specialDone.name;
      this.micro_name_spe = this.tabs!.specialPend.name;
      // this.tabs!.specialPend.active = true;
      this.micros_select_spe.setValue('---');
      this.tabs!.specialPend.pages = [];
      this.tabs!.specialPend.records = [];
      this.tabs!.specialPend.filtered = [];
      this.tabs!.specialPend.recordsShow = [];
      this.btn_restart_spe = '';
      this.offlineSrv.saveToLocal('specialGaugesPend', []);
    }
  }

  private onSearch(result: Array<any>): void {
    this.tabs!.searchSubs.pages = [];
    this.tabs!.searchSubs.recordsShow = [];
    this.tabs!.searchSubs.cards = [];
    let arrayAux: any = [];
    result.forEach(item => {
      arrayAux.push({
        subscriber: this.searchType === 'subscribers' ? item : null,
        client: this.searchType === 'clients' ? item : null,
      })
    })
    this.tabs!.searchSubs.records = arrayAux;
    this.tabs!.searchSubs.cards = arrayAux;
    arrayAux.length > 0 && this.setCards('search');
    this.loading = 'normal';
  }

  /**
   * Searches for subscribers or clients based on the input value.
   */
  search(): void {
    let search = this.search_input.value;

    if (search) {
      this.loading = 'loading';
      const petition: any =
        this.searchType === 'subscribers'
          ? this.subscriberSrv.getSubscribers(search)
          : this.clientSrv.getClients(search);
      this.subscriptions.push(
        petition.subscribe({
          next: (result: any[]) => {
            this.offlineSrv.saveToLocal(
              this.searchType === 'subscribers'
                ? 'subscribers_search'
                : 'clients_search',
              result,
            );
            this.onSearch(result);
          },
          error: (error: { error: { detailed: string } }) => {
            this.toastSrv.error(
              getErrorMessage(
                error,
                'No se pudo obtener los suscriptores o clientes.',
                this.no_internet,
              ),
            );
          },
        }),
      );
    }
  }

  private onSetMicroroutes(
    result: Array<Subscriber>,
    select_micro: string,
    micro_selected: any,
  ): void {
    if (select_micro) {
      this.micro_name = `MICRORRUTA ${micro_selected?.label}`.toUpperCase();
      this.tabs!.notGauging.active = true;
      this.tabSelected = this.tabs!.notGauging.name;
    }
    this.tabs!.notGauging.pages = [];
    this.tabs!.notGauging.cards = [];
    this.tabs!.notGauging.records = result;
    result.length > 0 && this.setCards('not_gauging');
    this.tabs!.notGauging.loading = false;
    this.setPaginator(1);
  }

  private onSetMicroroutesSpecials(
    result: any,
    select_micro: string,
    micro_selected: any,
  ): void {
    if (select_micro) {
      if (micro_selected?.label === 'Programado') {
        this.micro_name_spe = 'PROGRAMADOS';
        result.length === 0 &&
          (this.alertNoSpecials = 'No hay aforos especiales pendientes.');
      } else {
        this.micro_name_spe =
          `MICRORRUTA ${micro_selected?.label}`.toUpperCase();
        result.length === 0 &&
          (this.alertNoSpecials = 'No hay consumidores para aforar.');
      }
    } else {
      this.micro_name_spe = 'CONSUMIDORES PARA AFORAR ';
      result.length === 0 &&
        (this.alertNoSpecials = 'No hay consumidores para aforar.');
    }
    this.tabs!.specialPend.pages = [];
    this.tabs!.specialPend.cards = [];
    this.tabs!.specialPend.filtered = result;
    if (result.length > 0) {
      this.setCards('special_pend');
      micro_selected?.label === 'Programado' &&
        (this.tabs!.specialPend.exclamation = true);
    } else {
      micro_selected?.label === 'Programado' &&
        (this.tabs!.specialPend.exclamation = false);
    }
    this.tabs!.specialPend.loading = false;
  }

  /**
   *  Get the subscribers for the microroute selected
   * @param select - input select HTML
   * @param value - microroute value to load
   */
  setMicroroutes(
    select?: HTMLSelectElement,
    value?: { value: string; label: string },
  ): void {
    let micro_selected = select
      ? this.micros_values[select.selectedIndex]
      : this.micros_values.find((micro) => micro.value === value?.value);

    if (micro_selected?.value !== '---') {
      let select_micro =
        micro_selected?.value !== 'all' ? micro_selected?.value : '';
      this.offlineSrv.saveToLocal('microroute', micro_selected);
      this.btn_restart = 'Seleccionar microrruta';
      this.tabs!.notGauging.recordsShow = [];
      this.tabs!.notGauging.loading = true;
      if (this.no_internet) {
        this.onSetMicroroutes(
          this.offlineSrv.loadFromLocal('not_gauging', []),
          select_micro!,
          micro_selected,
        );
      } else {
        this.offlineSrv.saveToLocal('not_gauging', []);
        this.subscriptions.push(
          this.subscriberSrv.getSubscribersNotGauging(select_micro!).subscribe({
            next: (result: Subscriber[]) => {
              this.offlineSrv.saveToLocal('not_gauging', result);
              this.onSetMicroroutes(result, select_micro!, micro_selected);
            },
            error: (error: { error: { detailed: string } }) => {
              this.toastSrv.error(
                getErrorMessage(
                  error,
                  'No se pudo obtener los suscriptores para aforar.',
                  this.no_internet,
                ),
              );
            },
          }),
        );
      }
    }
  }

  /**
   *  Get the subscribers for the microroute selected
   * @param select - input select HTML
   * @param value - microroute value to load
   */
  setMicroroutesSpecial(
    select?: HTMLSelectElement,
    value?: { value: string; label: string },
  ): void {
    let micro_selected_spe = select
      ? this.micros_values_spe[select.selectedIndex]
      : this.micros_values_spe.find((micro) => micro.value === value?.value);

    if (micro_selected_spe?.value !== '---') {
      let select_micro =
        micro_selected_spe?.value !== 'all' ? micro_selected_spe?.value : '';
      this.offlineSrv.saveToLocal('microroute_spe', micro_selected_spe);
      this.btn_restart_spe = 'Seleccionar microrruta';
      this.tabs!.specialPend.recordsShow = [];
      this.tabs!.specialPend.loading = true;
      if (this.no_internet) {
        this.tabs!.specialPend.records = this.offlineSrv.loadFromLocal(
          'specialGaugesPend',
          [],
        );
        this.onSetMicroroutesSpecials(
          this.tabs!.specialPend.records,
          select_micro!,
          micro_selected_spe,
        );
      } else {
        this.offlineSrv.saveToLocal('specialGaugesPend', []);
        this.subscriptions.push(
          this.gaugingSrv
            .getSpecialGaugesPends(this.user?.id!, select_micro!)
            .subscribe({
              next: (result: any) => {
                this.offlineSrv.saveToLocal('specialGaugesPend', result);
                this.tabs!.specialPend.records = result;
                this.onSetMicroroutesSpecials(
                  result,
                  select_micro!,
                  micro_selected_spe,
                );
              },
              error: (error: { error: { detailed: string } }) => {
                this.toastSrv.error(
                  getErrorMessage(
                    error,
                    'No se pudo obtener los consumidores para aforar.',
                    this.no_internet,
                  ),
                );
              },
            }),
        );
      }
    }
  }

  setProgrammedOpt(
    select?: HTMLSelectElement,
    value?: { value: string; label: string },
  ): void {
    let option = select ? select.selectedIndex : value?.value;
    this.tabs!.specialPend.filtered = [];
    this.tabs!.specialPend.recordsShow = [];

    this.tabs!.specialPend.filtered =
      option == 0
        ? this.tabs!.specialPend.records
        : option == 1
          ? this.tabs!.specialPend.records?.filter(
              (record) => record.date === this.date_today.toLocaleDateString(),
            )
          : this.tabs!.specialPend.records?.filter(
              (record) => record.date !== this.date_today.toLocaleDateString(),
            );
    this.onSetMicroroutesSpecials(this.tabs!.specialPend.filtered, 'all', {
      label: 'Programado',
    });
  }

  /**
   * Sets the paginator to the specified page.
   * @param {number} page - The page number to set.
   */
  setPaginator(page: number): void {
    if (!this.tabs) return;

    let tabKey: keyof Tabs;

    switch (this.tabSelected) {
      case 'BUSCAR':
        tabKey = 'searchSubs';
        break;
      case 'SUSCRIPTORES AFORADOS':
        tabKey = 'gauging';
        break;
      case 'AFOROS ESPECIALES PENDIENTES':
        tabKey = 'specialPend';
        break;
      case 'AFOROS ESPECIALES REALIZADOS':
        tabKey = 'specialDone';
        break;
      default:
        tabKey = 'notGauging';
        break;
    }

    const tab = this.tabs[tabKey];

    const from = (page - 1) * this.card_x_page;
    const to = from + this.card_x_page;

    const sourceArray =
      tab.cards?.length! > 0
        ? tab.cards
        : tab.filtered?.length! > 0
          ? tab.filtered
          : (tab.records ?? []);
    tab.recordsShow = sourceArray!.slice(from, to);
    tab.pageSelect = page;
  }

  /**
   * Changes the active tab based on the selected tab event.
   * @param {*} evt - The event containing the selected tab information.
   */
  setTabs(evt: any): void {
    this.tabSelected = evt.name;
    this.setPaginator(1);
  }
}
